var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { Title } from '../../../Common';
import { Container, ArrowIcon, Summary, TitleContainer } from '../../Common';
import { AssignmentList } from './AssignmentList';
import { useCallback } from 'react';
var ScList = styled(AssignmentList).withConfig({ displayName: "ScList", componentId: "sc-1bb6dsa" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 18px;\n\n  background: #f3faff;\n"], ["\n  padding-top: 18px;\n\n  background: #f3faff;\n"])));
var InfoContainer = styled(Container).withConfig({ displayName: "InfoContainer", componentId: "sc-3uirj6" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  padding: 16px 32px 16px 4px;\n"], ["\n  display: flex;\n\n  padding: 16px 32px 16px 4px;\n"])));
var Info = styled.div.withConfig({ displayName: "Info", componentId: "sc-1fgi6xw" })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Letter = styled.div.withConfig({ displayName: "Letter", componentId: "sc-12fjrtq" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n\n  padding: 0px 6.5px;\n  margin-right: 4px;\n\n  color: ", ";\n  font-family: Noto Sans, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  background: ", ";\n  border-radius: 2px;\n"], ["\n  width: 24px;\n  height: 24px;\n\n  padding: 0px 6.5px;\n  margin-right: 4px;\n\n  color: ", ";\n  font-family: Noto Sans, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  background: ", ";\n  border-radius: 2px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.purple10;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.purple90;
});
var ScTitle = styled(Title).withConfig({ displayName: "ScTitle", componentId: "sc-1b7itob" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var AssignmentTopicItem = function (_a) {
    var streamData = _a.streamData, onExpand = _a.onExpand, className = _a.className, listProps = _a.listProps, rest = __rest(_a, ["streamData", "onExpand", "className", "listProps"]);
    var summary = streamData.summary, assignments = streamData.assignments;
    var _b = useToggle(), isOpen = _b.isToggled, toggleIsOpen = _b.toggle;
    var handleTopicClick = useCallback(function () {
        if (!isOpen)
            onExpand === null || onExpand === void 0 ? void 0 : onExpand();
        toggleIsOpen();
    }, [onExpand, toggleIsOpen, isOpen]);
    return (_jsxs("div", __assign({ className: className }, { children: [_jsxs(InfoContainer, __assign({ onClick: handleTopicClick, role: 'listitem', "data-name": 'assignment-topic-header' }, { children: [_jsx(Letter, { children: "A" }, void 0), _jsxs(Info, { children: [_jsxs(TitleContainer, { children: [_jsx(ScTitle, { children: "Teacher assignment(s)" }, void 0), _jsx(ArrowIcon, { "data-testid": 'arrow icon', open: isOpen }, void 0)] }, void 0), _jsx(Summary, { children: summary }, void 0)] }, void 0)] }), void 0), isOpen && assignments && (_jsx(ScList, __assign({ assignments: assignments }, listProps), void 0))] }), void 0));
};
export { AssignmentTopicItem };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
